import React from "react";
import "./Header.css";

import logoVidchain from "../../assets/images/vididentity_logo.svg";


function Header () {
    return (
      <header className="headerBackground">
        <img
          className="logoHeader"
          src={logoVidchain}
          alt="Logo"
          onClick={()=> window.location.replace("/demo")}
        />
        <a href="/demo/tutorial" className="tutorial">Start tutorial</a>
      </header>
    );
}

export default Header;
